import actions from "actions";
import Pagination from "components/Pagination/TablePagination";
import { connect } from "react-redux";
import { Link } from "react-router";
import {
  showDeleteGroupInviteConfirmationModal,
  showDeleteGroupMemberConfirmationModal,
} from "../../actions/mixed";
import axios from "axios";
import { API_GROUP_INVITES } from "../../constants/api";
import { toast } from "react-toastify";
import React, { Component } from "react";

const STATUSES = {
  accepted: "Accepted",
  pending: "Pending",
};

const titles = [
  { label: "Dr.", value: "dr" },
  { label: "Mr.", value: "mr" },
  { label: "Ms.", value: "ms" },
  { label: "Mrs.", value: "mrs" },
  { label: "Prof.", value: "prof" },
];

const labels = [
  "Title",
  "First name",
  "Last name",
  "Hospital",
  "County",
  "Member Authorisation Required",
  "Cancel Invitations",
  "Status",
];

const { getGroupMembers } = actions;

const approveInvitation = (id) => axios.put(`${API_GROUP_INVITES}/${id}`);

const buttonStyles = {
  display: "block",
  margin: "auto",
  background: "none",
  border: "none",
  color: "#2d98de",
  textDecoration: "underline",
};

class StudyGroupSuperhostMembers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      page: 1,
      per_page: 25,
    };
  }

  componentDidMount() {
    this.props.loadStudyGroupMembers({
      id: this.props.params.id,
      params: this.state,
    });
  }

  handleDelete = (id) => {
    this.props.showDeleteGroupMemberConfirmationModal({
      id,
      groupId: this.props.params.id,
      params: this.state,
    });
  };

  handleQueryChange = (search, timeout = 500) => {
    this.setState({ search }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(
        () =>
          this.props.loadStudyGroupMembers({
            id: this.props.params.id,
            params: this.state,
          }),
        timeout
      );
    });
  };

  onChangePage = (page) =>
    this.setState({ page }, () =>
      this.props.loadStudyGroupMembers({
        id: this.props.params.id,
        params: this.state,
      })
    );

  handleDeleteInvitation = (id) => {
    const { page, per_page } = this.state;

    this.props.showDeleteGroupInviteConfirmationModal({
      id,
      params: {
        page,
        per_page,
        id: this.props.params.id,
        search: this.state.search,
      },
    });
  };

  handleApproveInvitation = async (id) => {
    try {
      await approveInvitation(id);
      toast.success("Invitation has been approved!");
      this.props.loadStudyGroupMembers({
        id: this.props.params.id,
        params: this.state,
      });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const {
      studygroupMembers: { data, totalPages },
      params,
    } = this.props;

    const { search, page } = this.state;

    const groupId = params.id;

    return (
      <div style={{ width: "80%", margin: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            marginBottom: "12px",
          }}
        >
          <div className="container_admin_user">
            <div className="search_admin">
              <input id="search" type="submit" className="validate" />
              <label htmlFor="search">
                <i className="material-icons icon_search">search</i>
              </label>
              <input
                type="search"
                placeholder="Search"
                value={search}
                onChange={(e) => this.handleQueryChange(e.target.value)}
              />
              <i
                className="material-icons icon_close"
                onClick={() => this.handleQueryChange("")}
              >
                close
              </i>
            </div>
          </div>
          <Link to={`/groups/${groupId}/members/new`}>
            <button className="button_link">Invite New Member</button>
          </Link>
        </div>
        <div style={{ width: "100%", overflowX: "auto" }}>
          <table>
            <thead>
              <tr>
                {labels.map((label, idx) => (
                  <th key={idx} style={{ textAlign: "center" }}>
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <StudyGroupSuperhostMembersItem
                  key={item.id}
                  {...item}
                  groupId={groupId}
                  handleDelete={() => this.handleDelete(item.group_invite_id)}
                  handleApproveInvitation={() =>
                    this.handleApproveInvitation(item.group_invite_id)
                  }
                  handleDeleteInvitation={() =>
                    this.handleDeleteInvitation(item.group_invite_id)
                  }
                />
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          onChangePage={this.onChangePage}
          page={page}
          total_pages={totalPages}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  studygroupMembers: state.studygroups.members,
  currentUser: state.users.user,
});

const mapDispatchToProps = (dispatch) => ({
  loadStudyGroupMembers: (data) => dispatch(getGroupMembers(data)),
  showDeleteGroupMemberConfirmationModal: (payload) =>
    dispatch(showDeleteGroupMemberConfirmationModal(payload)),
  showDeleteGroupInviteConfirmationModal: (payload) =>
    dispatch(showDeleteGroupInviteConfirmationModal(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostMembers);

class StudyGroupSuperhostMembersItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const {
      title,
      first_name,
      last_name,
      hospital,
      county,
      handleDelete,
      group_invite: { status },
      handleApproveInvitation,
      handleDeleteInvitation,
    } = this.props;

    const { anchorEl } = this.state;

    const isPending = status === "pending";

    const label = titles.find(({ value }) => title === value).label || "";

    return (
      <tr>
        <td style={{ textAlign: "center" }}>{label}</td>
        <td style={{ textAlign: "center" }}>{first_name}</td>
        <td style={{ textAlign: "center" }}>{last_name}</td>
        <td style={{ textAlign: "center" }}>{hospital}</td>
        <td style={{ textAlign: "center" }}>{county}</td>
        <td>
          {isPending && (
            <button style={buttonStyles} onClick={handleApproveInvitation}>
              Accept Invitation
            </button>
          )}
        </td>
        <td>
          {isPending && (
            <button style={buttonStyles} onClick={handleDeleteInvitation}>
              Cancel Invitation
            </button>
          )}
        </td>
        <td style={{ textAlign: "center" }}>{STATUSES[status]}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/StudyGroupSuperhostMembers.jsx